import DisableAutocomplete from 'vue-disable-autocomplete';

<template>
  <div>
    <select :name="question.prompt"
    :value="setValue()"
    :id="answer_increment? question.answer.id.toString() + answer_increment: question.answer.id"
    class="form-control select"
    :categoryId="categoryId">
      <option disabled value="">Please select one</option>
      <option v-for="option in question.options"
              v-bind:key="option.id"
              v-bind:value="option.choice"
              :id="option.id"
              :name="option.choice"
              autocomplete = "off">
        {{option.choice}}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props:{
    question: Object,
    answer_increment: String,
    multipleIndex: Number,
    categoryId: Number
  },
  data(){
    return {}
  },
  methods: {
    setValue() {
      if (typeof(this.$props.question.answer.value) === 'object') {
        if (this.$props.multipleIndex) {
          //use the saved value for this answer instance
          return this.$props.question.answer.value[this.$props.multipleIndex].value
        } else {
          //use the blank "default" value until we save this instance
          return this.$props.question.answer.value[0].value
        }
      } else {
        return this.$props.question.answer.value
      }
    }
  }
}
</script>

<style>

</style>
